import $ from 'jquery';

$(window).on('load', function () {
  $(document).on('click', '.faq__item__header', function () {
    if ($(this).hasClass('closed')) {
      $(this).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
    } else {
      $(this).find('.fa-minus').removeClass('fa-minus').addClass('fa-plus');
    }
    $(this).toggleClass('closed').toggleClass('open').next().slideToggle();
  });
});
